const managementUsersCache = { expiresAt: 0, data: null };

export function getManagementUsers(instance, force = false) {
    if (!force && managementUsersCache.data && managementUsersCache.expiresAt > Date.now()) {
        return Promise.resolve({ data: { code: 1, data: managementUsersCache.data } });
    }
    return instance.post('/lawsuitCase/plan/managementUsers', {}).then((res) => {
        if (res.data && res.data.code == 1) {
            managementUsersCache.data = res.data.data || [];
            managementUsersCache.expiresAt = Date.now() + 5 * 60 * 1000;
        }
        return res;
    });
}

export function addPlan(instance, payload) { return instance.post('/lawsuitCase/plan/addPlan', payload); }
export function acceptPlan(instance, payload) { return instance.post('/lawsuitCase/plan/acceptPlan', payload); }
